var SERVER_SPEC_MENTION = /<(@|#)([^>:]+?)>/g;
var RENDER_SPEC_MENTION = /<(@|#)([^>]+?):([^>]+?)>/g;
var HIGHLIGHTED_TEXT_REGEX = /<(highlighted) ([^>:]+?)>/g;
var COMMON_REGEX = /<([^>:]+?)\|([^>:]+?)\|([^>:]+?)>/g;

export { COMMON_REGEX, HIGHLIGHTED_TEXT_REGEX, RENDER_SPEC_MENTION, SERVER_SPEC_MENTION };
